import "./WorldMapLegend.css";

import { DEFAULT_MAP_LAYERS, MAP_DISPLAY_MODES } from "../../constants";

import { WorldMapLegendItem } from "./WorldMapLegendItem";
import { useSelector } from "react-redux";

export const WorldMapLegend = () => {
  const mapLayers = useSelector(({ resultMap }) => resultMap.mapLayers);
  const mapDisplayMode = useSelector((state) => state.resultMap.mapDisplayMode);
  const isFieldMapMode = mapDisplayMode === MAP_DISPLAY_MODES.FIELD_MAP;

  return (
    <div id="worldmap-legend" className="d-flex flex-column">
      {mapLayers
        .toSorted((a, b) => a.priority - b.priority)
        .map((layer) => {
          return !(
            layer.id === DEFAULT_MAP_LAYERS.FEATURES_LAYER && isFieldMapMode
          ) ? (
            <WorldMapLegendItem layer={layer} key={layer.id} />
          ) : null;
        })}
    </div>
  );
};
